import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';

const placeholderImg = (text = 'No Image') => {
  return `https://placehold.co/600x400/f0f0f0/333333?text=${encodeURIComponent(text)}`;
};

function ItemCard({ item }) {
  const [imgSrc, setImgSrc] = useState(item.Photo);

  //  const navigate = useNavigate();

  const handleError = () => {
    setImgSrc(placeholderImg(item.Photo));
  };

  const handleCardClick = () => {
    // navigate("/cartitem", {
    //   state: { 
    //     code: item.ItemGroup   
    //   }
    // });
  };

  const formattedPrice = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  }).format(item.price);

  return (
    <div onClick={() => handleCardClick(item.Name)} className="bg-slate-800 rounded-xl shadow-xl shadow-black/20 overflow-hidden flex flex-col transition-all duration-300 ease-in-out hover:scale-105 hover:bg-slate-700">
      <div className="h-48 w-full overflow-hidden">
        <img
          src={"data:image/jpeg;base64,"+imgSrc}
          alt={item.Name}
          className="w-full h-full object-cover"
          onError={handleError}
        />
      </div>
      
      <div className="p-4 flex flex-col flex-grow">
        <h3 className="text-xl font-semibold text-white mb-1 truncate">{item.Name}</h3>
        {/* <p className="text-2xl font-bold text-green-400 mt-auto">{formattedPrice}</p> */}
      </div>
    </div>
  );
}

export default function App() {
  const [allCategories,setAllCategories]= useState([])

  useEffect(()=>{
    fetch_Categ();
  },[])

function fetch_Categ() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = {
        RestCode: "HO10",
        dbIP: "web.dataman.in",
        database: "demo",
        dbusername: "sa",
        dbpassword: "Dcspl@#$345"
    };
    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(raw) 
    };
    fetch("/api/dmaatithya/AppService.asmx/GetCategory", requestOptions)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then(result => {
            console.log("category result object:", result);
            const category = result?.d; 
            setAllCategories(category); 
        })
        .catch(error => console.log("Fetch error:", error));
}

  return (
    <div className="bg-slate-900 min-h-screen p-4 sm:p-8 font-inter">
      <div className="max-w-7xl mx-auto">
        <header className="mb-8">
          <h1 className="text-4xl font-extrabold text-center text-white tracking-tight">
            Kiosk Menu
          </h1>
        </header>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {allCategories.map((item) => (
            <ItemCard key={item.ItemGroup} item={item} />
          ))}
        </div>

        {allCategories.length === 0 && (
          <div className="text-center p-12 bg-slate-800 rounded-xl shadow-md">
            <h3 className="text-2xl font-semibold text-gray-400">No items yet!</h3>
            {/* <p className="text-gray-500 mt-2">Use the form above to add your first item.</p> */}
          </div>
        )}
      </div>
    </div>
  );
}